import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BottombarComponent } from './component/bottombar/bottombar.component';
import { TopmenubarComponent } from './component/topmenubar/topmenubar.component';
import { HomeComponent } from './page/home/home.component';
import { DailyComponent } from './page/daily/daily.component';
import { SigninComponent } from './page/signin/signin.component';
import { SignupComponent } from './page/signup/signup.component';
import { HeaderComponent } from './component/header/header.component';
import { TopbarComponent } from './component/topbar/topbar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ContactComponent } from './page/contact/contact.component';
import { PriceComponent } from './page/price/price.component';
import { ServiceComponent } from './page/service/service.component';

@NgModule({
  declarations: [
    AppComponent,
    BottombarComponent,
    TopmenubarComponent,
    HomeComponent,
    DailyComponent,
    SigninComponent,
    SignupComponent,
    HeaderComponent,
    TopbarComponent,
    ContactComponent,
    PriceComponent,
    ServiceComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { }
